import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { bool, shape, func, string, number } from "prop-types";
import { routerActions } from "react-router-redux/actions";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";

import * as configUtils from "util/config";
import * as i18nUtils from "util/i18n";
import { goBack } from "react-router-redux";

import Navbar from "pages/_components/Navbar";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import MainContainer from "pages/_components/MainContainer";

import PaymentLinesModal from "pages/_components/Modal";
import PaymentLinesForm from "pages/forms/_components/_fields/_transactionlines/Form";
import TransactionLinesList from "pages/forms/_components/_fields/_transactionlines/List";
import TransactionLinesFilters from "pages/forms/_components/_fields/_transactionlines/Filters";
import TransactionLinesFiltersForm from "pages/forms/_components/_fields/_transactionlines/FiltersForm";
import PaymentLinesButtons from "pages/forms/_components/_fields/_transactionlines/PaymentLinesButtons";
import PageLoading from "pages/_components/PageLoading";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

class PaymentLines extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        isConfirmation: bool,
        isEditingPayment: bool.isRequired,
        renderMoreDetails: func,
        isFetching: bool.isRequired,
        dispatch: func.isRequired,
        match: shape({ url: string.isRequired }).isRequired,
        totalLines: number.isRequired,
        isTicket: bool,
        isLastPage: bool,
        onDownloadClick: func.isRequired,
        paymentCurrency: string.isRequired,
        transaction: shape({
            idTransaction: string,
        }).isRequired,
    };

    static defaultProps = {
        isConfirmation: false,
        renderMoreDetails: null,
        isTicket: false,
        isLastPage: false,
    };

    state = {
        isExpanded: false,
        filter: undefined,
        filterData: null,
    };

    handleCloseClick = () => {
        this.navigate(routerActions.push("/desktop"));
    };

    handleBackClick = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    navigate = (action) => {
        const { dispatch } = this.props;
        dispatch(action);
    };

    hasFilters = () => {
        const { totalLines } = this.props;
        return totalLines > configUtils.get("transactions.rowsPerPage", 10);
    };

    handleCollapseClick = () => {
        this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
    };

    handleFilterSubmit = ({ filter, data }) => {
        const minAmount = data.minAmount && data.minAmount.amount;
        const maxAmount = data.maxAmount && data.maxAmount.amount;
        const { accountName, creditAccount, accountBank } = data;
        const { dispatch, transaction, isTicket } = this.props;
        const { filterData } = this.state;
        if (isTicket) {
            this.setState(
                {
                    filterData: {
                        minAmount,
                        maxAmount,
                        accountName,
                        creditAccount,
                        accountBank,
                    },
                },
                () => {
                    dispatch(transactionLinesActions.onFiltersChanged(filterData));
                    dispatch(transactionLinesActions.clearTransactionLines());
                    dispatch(
                        transactionLinesActions.listTransactionLinesRequest({
                            id: transaction.idTransaction,
                            pageNumber: 1,
                            ...filterData,
                        }),
                    );
                    dispatch(transactionLinesActions.setPageNumber(0));
                },
            );
        } else {
            this.setState({
                filter: (line) => {
                    switch (filter) {
                        case "amount": {
                            return TransactionLinesFiltersForm.filters[filter](
                                minAmount,
                                maxAmount,
                                line.creditAmountQuantity,
                            );
                        }
                        case "payee": {
                            return TransactionLinesFiltersForm.filters[filter](accountName, line.creditAccountName);
                        }
                        case "account": {
                            return TransactionLinesFiltersForm.filters[filter](creditAccount, line.creditAccountNumber);
                        }

                        case "reference":
                            return TransactionLinesFiltersForm.filters[filter](accountBank, line.bankIdentifier);
                        default: {
                            return true;
                        }
                    }
                },
                filterData: {
                    minAmount,
                    maxAmount,
                    accountName,
                    creditAccount,
                },
            });
            dispatch(transactionLinesActions.setPageNumber(0));
        }
    };

    handleCloseModal = () => {
        const { dispatch } = this.props;
        dispatch(transactionLinesActions.setIsEditingPayment(false));
    };

    handleFinishClick = () => {
        const { dispatch } = this.props;
        dispatch(transactionLinesActions.setIsEditingPayment(false));
    };

    renderMobile = () => {
        const { onDownloadClick } = this.props;
        if (onDownloadClick) {
            return onDownloadClick();
        }
        return null;
    };

    handleSubmit = (values) => {
        const { dispatch } = this.props;
        dispatch(transactionLinesActions.addTransactionLine(values));
    };

    renderModal(initialValues) {
        const { isEditingPayment } = this.props;

        const paymentsModal = (
            <PaymentLinesModal
                handleDismiss={this.handleCloseModal}
                hasDismissButton
                isModalDisplayed={isEditingPayment}
                title={i18nUtils.get("salaryPayment.manual.addPayment.title")}>
                <PaymentLinesForm
                    initialValues={initialValues}
                    submitButtonLabel="salaryPayment.manual.addPayment.addAndContinue"
                    cancelButtonHandler={this.handleCloseModal}
                    onSubmit={this.handleSubmit}
                />
            </PaymentLinesModal>
        );

        return ReactDOM.createPortal(paymentsModal, document.querySelector("#modal"));
    }

    renderDesktop = () => {
        const {
            isDesktop,
            isEditingPayment,
            isConfirmation,
            paymentCurrency,
            isTicket,
            isFetching,
            isLastPage,
        } = this.props;
        const { isExpanded, filter } = this.state;
        const initialValues = {
            creditAccountNumber: "",
            creditAccountName: "",
            credit: {
                currency: paymentCurrency,
                amount: "",
            },
            bankIdentifier: "",
        };
        const { match } = this.props;
        const backUrl = match.url
            .split("/")
            .slice(0, -1)
            .join("/");
        return (
            <MainContainer showLoader={isFetching}>
                <div className="above-the-fold">
                    {this.hasFilters() && !(isConfirmation || isTicket) && (
                        <Container className="container--layout">
                            <Container.Column>
                                <div className="table-title-wrapper">
                                    {this.hasFilters() && (
                                        <TransactionLinesFilters
                                            hasState={false}
                                            isExpanded={isExpanded}
                                            selectedFilter={null}
                                            onFilterClick={null}
                                            onCollapseClick={this.handleCollapseClick}
                                        />
                                    )}
                                </div>

                                {!(isConfirmation || isTicket) && (
                                    <PaymentLinesButtons isEditingPayment={isEditingPayment} backUrl={backUrl} />
                                )}
                                {this.hasFilters() && (
                                    <TransactionLinesFiltersForm
                                        onSubmit={this.handleFilterSubmit}
                                        isExpanded={isExpanded}
                                        currency={configUtils.get("core.masterCurrency")}
                                    />
                                )}
                            </Container.Column>
                        </Container>
                    )}
                    <Container.Column style={{ padding: "0px" }}>
                        <TransactionLinesList
                            filter={filter}
                            noMoreDataText={isDesktop && "transaction.process.noMoreTransactions"}
                            loadMoreText={isDesktop && "massive.payments.line.more.results"}
                            noDataImage="images/coloredIcons/no-more-transactions.svg"
                            noDataText="transaction.process.none"
                            isReadOnly={isConfirmation || isTicket}
                            isTicket={isTicket}
                            isLastPage={isLastPage}
                        />
                    </Container.Column>
                </div>
                {!isConfirmation && this.renderModal(initialValues)}
            </MainContainer>
        );
    };

    render() {
        const { isDesktop, renderMoreDetails, isFetching, isConfirmation } = this.props;
        const showConfirmationHeader = isConfirmation && !isUxDashboardImprovementsEnabled();
        return (
            <Fragment>
                <PageLoading loading={isFetching}>
                    {showConfirmationHeader && (
                        <header className="view-header">
                            <Navbar>
                                <Navbar.Item align="left">
                                    <Button
                                        className="toolbar-btn view-back"
                                        onClick={this.handleBackClick}
                                        image="images/arrowLeft.svg"
                                        bsStyle="link"
                                        label="global.back"
                                    />
                                </Navbar.Item>
                            </Navbar>
                            {renderMoreDetails && isDesktop && renderMoreDetails()}
                        </header>
                    )}
                    {isDesktop ? this.renderDesktop() : this.renderMobile()}
                </PageLoading>
            </Fragment>
        );
    }
}

export default PaymentLines;
